import InfoIcon from "components/shared/iconInfo";
import React, { useState } from "react";

const TagsItem = ({ item }) => {
    const [copied, setCopied] = useState(false);
    const copyToClipboard = () => {
        if (copied) {
            return null;
        }
        setCopied(true);
        navigator.clipboard.writeText(`{${item.text}}`);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };
    return (
        <li>
            {item.text} &mdash; <code className="font-size-12">{`{${item.text}}`}</code>
            <div className="btn btn-xs btn-secondary ml-2" onClick={copyToClipboard}>
                {copied ? (
                    <span>
                        <i className="icon-uEA54-checkmark inline-icon pr-1 font-size-12" />
                        Cкопировано
                    </span>
                ) : (
                    "Скопировать"
                )}
            </div>
        </li>
    );
};

export default function TagsList({ documentTags }) {
    const [selectedTag, setSelectedTag] = useState("all");

    return (
        <div className="card card-body my-3">
            <div className="d-flex mb-2 justify-content-between align-items-center">
                <div className="flex-1">Список тегов</div>
                <select
                    className="form-control form-control-sm w-auto"
                    onChange={(e) => setSelectedTag(e.target.value)}
                    value={selectedTag}
                >
                    <option value="all">Все группы</option>
                    {documentTags.map((group) => (
                        <option key={group.i} value={group.text}>
                            {group.text}
                        </option>
                    ))}
                </select>
            </div>
            <ul className="list-group list-group-flush pt-3">
                {documentTags.map((group, i) =>
                    selectedTag === "all" || group.text === selectedTag ? (
                        <li key={i} className="list-group-item">
                            <strong>{group.text}</strong>
                            {group.tooltip && <InfoIcon text={group.tooltip} placement="right" />}
                            <ul>
                                {group.items.map((item, l) => (
                                    <TagsItem key={l} item={item} />
                                ))}
                            </ul>
                        </li>
                    ) : null,
                )}
            </ul>
        </div>
    );
}
